import { Injectable } from '@angular/core';

import { LogLevel } from 'app/core/logging/constants/log-level.constant';
import { LoggingServiceInterface } from 'app/core/logging/services/logging-service.interface';

@Injectable()
export class LoggingService implements LoggingServiceInterface {
  /**
   * log
   *
   * Log a message with a severity level
   *
   * @param level Severity level of message being logged
   * @param message Message to log
  */
  public log(level: LogLevel, message: string): void {
    const logMessage: string = `${level}: ${message}`;

    try {
      switch (level) {
        case LogLevel.critical:
        case LogLevel.error:
          console.error(logMessage);
          break;

        case LogLevel.warn:
          console.warn(logMessage);
          break;

        default:
          console.log(logMessage);
      }
    } catch (_) {
      console.log(logMessage);
    }
  }
}
